import React from "react";
import styles from "../../styles/_containers/_reviews/statsBar.module.scss";

export default function StatsBar({ stats }) {
  if (!stats) return null;
  const { averageRating, totalCount, distribution } = stats;

  return (
    <div className={styles.container}>
      <div className={styles.average}>
        <span className={styles.avgNumber}>{averageRating || 0}</span>
        <span className={styles.avgStar}>★</span>
        <span className={styles.avgLabel}>{totalCount} ביקורות</span>
      </div>
      <div className={styles.bars}>
        {[5, 4, 3, 2, 1].map(star => {
          const count = distribution?.[star] || 0;
          const pct = totalCount > 0 ? Math.round((count / totalCount) * 100) : 0;
          return (
            <div key={star} className={styles.barRow}>
              <span className={styles.barLabel}>{star} ★</span>
              <div className={styles.barTrack}>
                <div className={styles.barFill} style={{ width: `${pct}%` }} />
              </div>
              <span className={styles.barCount}>{count}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
